import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useGetZendeskMessagingTokenQuery = () => {
  const { mutateAsync, isLoading } = useMutation(() => api.post(API_URL.ZENDESK_MESSAGING_TOKEN));

  const getZendeskMessagingToken = useCallback(async () => {
    const data = await mutateAsync();
    const token = data?.data?.token;
    return token;
  }, [mutateAsync]);

  return {
    getZendeskMessagingToken,
    isZendeskMessagingTokenLoading: isLoading,
  };
};

export default useGetZendeskMessagingTokenQuery;
